<!-- 轮播图首页 -->
<template>
  <div class="page-module-wrap">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="selectTab">
          <p class="title">轮播模块</p>
          <el-tabs v-model="activeName">
            <el-tab-pane label="内容管理" name="contentManager">
              <div class="carousel-list-container">
                <p class="buttonStyle fleft">
                  <span class="button is-success" @click="addCarousel">新增</span>
                </p>
                <div class="carousel-list-wrap block">
                  <div v-if="initialData.count > 0" class="clearfix fright" style="margin-bottom: 20px;">
                    <el-pagination
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next, jumper"
                      :total="initialData.count">
                    </el-pagination>
                  </div>
                  <table class="table is-bordered is-fullwidth">
                    <thead>
                    <tr>
                      <th>ID</th>
                      <th>图片</th>
                      <th>标题以及访问量</th>
                      <th>状态</th>
                      <th>排序号</th>
                      <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr class="list-cell" v-for="(item,index) in initialData.list">
                        <td>
                          {{item.contentId}}
                          <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
                          <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
                          <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
                          <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
                        </td>
                        <td>
                            <image-component :image='item.image.image' :width='150'></image-component>
                        </td>
                        <td>
                          <p class="title content-title">标题:{{item.title}}</p>
                          <p class="clickCount">点击数<span class="num" v-for=" (subItem,index) in item.stats">{{ subItem }}</span><span v-if=" item.stats.length > 0 && index !== item.stats.length-1">/</span></p>
                        </td>
                        <td>
                          <p class="time">{{item.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}} ~ {{item.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}} </p>
                        </td>
                        <td>
                          <div class="sort-wrap">排序号</br>
                            <input class="input width-1" @change="onCarouselSort(item.contentId, item.sort)" v-model="item.sort">
                          </div>
                        </td>
                        <td>
                          <p>
                            <span class="button is-info" @click="goEdit(item)">编辑</span>
                            <span class="button is-danger" @click="onCarouselDelete(item.contentId, index)">删除</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="initialData.count > 0" class="clearfix fright">
                    <el-pagination
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next, jumper"
                      :total="initialData.count">
                    </el-pagination>
                  </div>

                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="模块设置" name="moduleSetting">
              <div class="tile is-parent">
                <article class="tile is-child box">
                  <div class="topic-set-module-container">
                    <div class="block">
                      <p class="title">
                        <span class="radio r-top">
                          <input type="checkbox" id="showName" name="showName" v-model="setModule.showTitle" >
                          <label for="showName" class="title">是否展示标题</label>
                        </span>
                      </p>
                      <input class="block input width-3" v-model="setModule.title">
                    </div>
                    <div class="block titleMargin">
                      <span class="radio r-top">
                      <p class="title">显示 "查看全部" <i>(客户端不需要展示则留空)</i></p>
                        <input class="block input width-3" v-model="setModule.moreTitle">
                      </span>
                    </div>

                    <p class="title margin-top30">"查看全部" 跳转链接</p>
                    <div class="block cyzs-w-400">
                      <custom-link :link='setModule.moreLink' @update:link="val => { setModule.moreLink = val }"></custom-link>
                    </div>
                    <p class="title titleMargin" style="margin-bottom: 5px;">显示状态</p>
                    <div class="block">
                      <input type="radio" value="1" v-model="setModule.status" name="setStatus"><label>开启</label>
                      <input type="radio" value="0" v-model="setModule.status" name="setStatus"><label>关闭</label>
                    </div>
                    <div>
                    </div>
                    <div class="slider-wrap">
                      <p class="title">
                        与上一模块间距（px）
                        <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                          <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                        </el-tooltip>
                      </p>
                      <p>
                        <el-slider v-model="setModule.marginTop" :max="400" :show-input="true"></el-slider>
                      </p>
                    </div>
                    <div v-if="routerName == 'discovery'" class="slider-wrap">
                      <div class="title">是否展示底部分割线</div>
                      <div class="block">
                        <label><input type="radio" :value="1" v-model="setModule.isShowTopLine" name="isShowTopLine">是</label>
                        <label><input type="radio" :value="0" v-model="setModule.isShowTopLine" name="isShowTopLine">否</label>
                      </div>
                    </div>
                  </div>
                      <div class="inline-block" style="margin: 60px 0 40px 0;">
                        <p>
                          <button class="button is-primary"  @click="saveCarousel">保存</button>
                          <button class="button is-danger" v-if="setModule.status*1 !== 2 && currentFashionMenu.moduleId" @click="onArchive(setModule.status*1)">归档模块</button>
                          <button class="button is-info" v-if='setModule.status*1 ===2' @click='onArchive(setModule.status*1)'>还原模块</button>
                        </p>
                      </div>
                </article>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </article>
    </div>
  </div>
</template>

<script type="text/babel">
  import CustomLink from 'COMMON/DefinedLink';
  import { mapState, mapActions } from 'vuex';

  export default {
    components:{
      CustomLink, 
    },
    props: {

    },
    computed: {
      marginTopPer () {
        return `${this.setModule.marginTop}px`
      },
      marginLeftPer () {
        return `${this.setModule.marginLeft}px`
      },
    },
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page*1;
      }
      if (this.currentFashionMenu.moduleType == -1) {
        this.setCurrentFashionMenuByVuex({
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId
        })
      } else {
        this.init()
      }
	  this.routerName = this.$route.name
	},
    computed: {
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      })
    },
    watch: {
      currentFashionMenu: {
        handler(val) {
          this.init()
        },
        deep: true
      }
    },
    data(){
      return {
        activeName: 'contentManager',
        currentPage: 1,
        pageSize: 10,
        initialData: {
          list:[],
          count:0
        },
        status:1,
        //模块设置
        setModule:{
          showTitle: false,
          title:"",
          status:1,
          marginTop: 50,
          moreLink: '',
          isShowTopLine: 1,
        },
        moduleId: '',
        moduleSettingSelected: false,
		routerName: ''
	  }
    },

    methods: {
      handleCurrentChange(page) {
        if (this.currentPage !== page) {
          this.currentPage = page
          this.getCarouselList()
        }
      },
      init() {
        this.showEdit = false
        this.moduleSettingSelected = !this.currentFashionMenu.moduleId
        if (this.moduleSettingSelected) {
          this.activeName = 'moduleSetting';
          this.setModule = {
            showTitle:false,
            title: '',
            status: 1,
            marginTop: 50,
            moreLink: '',
          }
          this.initialData.list = [];
          this.initialData.count = 0;
        } else {
          this.activeName = 'contentManager';
          this.getCarouselList();
          this.getInitialData();
        }
      },
      getCarouselList() {
        let _params = {
          type: 0,
          moduleId: this.currentFashionMenu && this.currentFashionMenu.moduleId || '',
          page:this.currentPage,
          pageSize: this.pageSize,
        }
        HttpRequest.get('/admin.php?method=fashion.getModuleContentList', _params).then(response => {
          this.initialData.list = _.toArray(response.data.list);
          this.initialData.count = response.data.count;
        })
      },
      onCarouselDelete(_id, index) {
        if (confirm('是否确定删除?')) {
          let params = {
            contentId: _id,
          }
          HttpRequest.post("/admin.php?method=fashion.deleteModuleContent",params, true).then((response) => {
            if(response.data.success == 1){
              this.$message("删除成功！")
              this.initialData.list.splice(index,1);
            }
          }, (response) => {

          });
        }
      },
      onCarouselSort(contentId, sort) {
        let params = {
          contentId: contentId,
          sort: sort,
        }
        HttpRequest.get("/admin.php?method=fashion.doSaveModuleContentSort",params, true).then((response) => {
          if(response.data.success == 1){
            this.$message("修改成功")
            this.getCarouselList();
          }
        }, (response) => {

        });
      },
      getInitialData() {
        let _params = {
          moduleId: this.currentFashionMenu && this.currentFashionMenu.moduleId || '',
        };
        HttpRequest.post("/admin.php?method=fashion.getModule", _params, true).then((response) => {
          this.setModule = response.data;
          this.setModule.marginTop = this.setModule.marginTop * 2;
          this.setModule.showTitle = response.data.showTitle == 1;
          this.setModule.isShowTopLine = response.data.isShowTopLine ? 1 : 0;
          this.status = response.data.status;

        }, (error) => {

        });
      },
      //获取模块设置数据
      //保存模块设置
      saveCarousel() {
        if(this.setModule.moreTitle){
          if(!this.setModule.moreLink){
            this.$message("请输入自定义链接！");
            return
          }
        }else{
          this.setModule.moreLink = "";
        }
        let params = Object.assign({},this.setModule,this.currentFashionMenu);
        params.marginTop = params.marginTop / 2;
        params.showTitle = this.setModule.showTitle ? 1 : 0;
        params.isShowTopLine = this.setModule.isShowTopLine ? 1 : 0;
        HttpRequest.post("/admin.php?method=fashion.doSaveModule", params, true).then((response) => {
          if (response.data.success == 1) {
            this.$message('保存成功');
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            }, 2000)
          } else {
            this.$message('接口错误,请联系管理员');
          }
        }, (error) => {

        });
      },
      onArchive(status) {
        let _params = {
          moduleId: this.currentFashionMenu.moduleId && this.currentFashionMenu.moduleId || '',
          actionType: 0,
        }
        if ( status ===2 ) {
          _params.actionType = 1;
        } else {
          _params.actionType = 0;
        }
        HttpRequest.post("/admin.php?method=fashion.archiveModule", _params, true).then((response) => {
          if (response.data.success == 1) {
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            }, 2000)
            this.$message('操作成功');
          } else {
            this.$message('接口错误,请联系管理员');
          }
        }, (error) => {

        });
      },
      getQuery(query = {}) {
        let params = {
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId 
        }
        return Object.assign(query, params)
      },
      addCarousel() {
        if (this.currentFashionMenu.moduleId) {
          this.$router.push({
            name: 'editCarousel',
            query: this.getQuery({ topicId: '', operationType: 'add'})
          })
        } else {
          this.$message('请先完成模块设置')
        }
      },
      goEdit(item) {
        this.$router.push({
          name: 'editCarousel',
          query: Object.assign({ page: this.currentPage },this.getQuery({ contentId: item.contentId, operationType: 'edit'}))
        })
      },
      ...mapActions([
        'commitFashionMenuUpdate', 'setCurrentFashionMenuByVuex'
      ]),
    }
  }
</script>

<style lang="less" scoped>
  .page-module-wrap{
    .buttonStyle {
      max-width: 50px;
      margin-bottom: 20px;
    }
    .carousel-list-wrap{
      .list-cell{
        .title{
          font-family: "微软雅黑";
          margin-bottom: 20px;
          padding: 0;
        }
        .clickCount {
          font-size: 14px;
          color: #222233;
          margin-bottom: 65px;
          .num {
            margin-left: 10px;
          }
        }
        .time{
          margin-bottom: 20px;
          width: 150px;
          white-space: normal;
        }
        .sort-wrap{
          margin-top: 34px;
        }
      }
    }

    .titleMargin {
    margin: 10px 0 !important;
  }
  .margin-top30 {
    margin-top: 30px;
  }

  .ad-list-container{
    margin: 30px 0;
    .list-cell{
      .img-rel-wrap{
        width: 300px;
        height: 180px;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
        }
      }
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
  .topic-set-module-container{
    margin: 30px 0 0 4px;
    .slider-wrap{
      width: 300px;
      margin-top: 40px;
      .tooltip-value{
        margin-left: 20px;
      }
      .input-slider{
        margin-top: 30px;
      }
    }
    .custom-link-wrap{
      z-index: 999999999;
      position: relative;
      border-radius: 6px;
      border: 1px solid #00d1b2;
      width: 300px;
      padding: 20px;
    }
  }
}
  .content-title{
    white-space: normal;
    line-height: 1.2;
    display: inline-block;
  }
</style>
